module.exports = __webpack_public_path__ + "img/广元奥斯文.9afe108.png";